import React, { Component } from "react";
import _ from "lodash";
import T from "prop-types";
import classNames from "classnames";

function TableHead({ children }) {
  return (
    <thead>
      <tr>{children}</tr>
    </thead>
  );
}

TableHead.propTypes = {
  children: T.arrayOf(T.element)
};

function PlaceholderRow() {
  return <tr style={{ visibility: "hidden", height: "30px" }} />;
}

function LoadingRows({ rows, columns }) {
  const tableCell = i => <td key={i} colSpan={1} />;

  return _.times(rows, i => (
    <tr className="animate-row" style={{ height: 30 }} key={i}>
      {_.times(columns, tableCell)}
    </tr>
  ));
}

function TableBody({
  children,
  isLoading,
  columnCount,
  loadingRows,
  loadAnimation
}) {
  if (isLoading && loadAnimation) {
    return (
      <tbody>
        <LoadingRows rows={loadingRows} columns={columnCount} />
      </tbody>
    );
  }
  return <tbody>{children.length > 0 ? children : <PlaceholderRow />}</tbody>;
}

TableBody.propTypes = {
  children: T.arrayOf(T.element),
  isLoading: T.bool,
  columnCount: T.number,
  loadingRows: T.number,
  loadAnimation: T.bool
};

export function MiniDataTable(props) {
  return (
    <DataTable loadingRows={1} {...props} responsive={false}>
      {props.children}
    </DataTable>
  );
}

MiniDataTable.propTypes = {
  children: T.arrayOf(T.element)
};

export default class DataTable extends Component {
  static Mini = MiniDataTable;

  static Head = TableHead;

  static Body = TableBody;

  static propTypes = {
    children: T.arrayOf(T.element),
    refresh: T.func,
    loading: T.bool,
    numbered: T.bool,
    withoutBaseline: T.bool,
    noMargin: T.bool,
    responsive: T.bool,
    striped: T.bool.isRequired,
    loadingRows: T.number,
    style: T.string
  };

  state = {
    loadAnimation: true
  };

  componentDidMount() {
    if (this.props.refresh) {
      this.intervalId = window.setInterval(() => {
        this.setState({ loadAnimation: false });
        this.props.refresh.bind(this)();
      }, 30000);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.loading === false) {
      this.setState({ loadAnimation: true });
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  render() {
    const {
      children,
      loading,
      numbered,
      noMargin,
      loadingRows,
      withoutBaseline,
      responsive,
      striped,
      style
    } = this.props;

    const childrenWithProps = React.Children.map(children, child =>
      React.cloneElement(child, {
        isLoading: loading,
        loadAnimation: this.state.loadAnimation,
        columnCount: children[0].props.children.length,
        loadingRows
      })
    );

    const tableClasses = classNames("table table-hover", {
      "table-striped": striped,
      "table-numbered": numbered,
      "margin-bottom-none": noMargin,
      "no-baseline": withoutBaseline
    });

    const table = (
      <table style={style} className={tableClasses}>
        {childrenWithProps}
      </table>
    );

    return responsive ? (
      <div className="table-responsive" style={{ whiteSpace: "nowrap" }}>
        {table}
      </div>
    ) : (
      table
    );
  }
}

DataTable.defaultProps = {
  numbered: false,
  noMargin: false,
  striped: true,
  withoutBaseline: false,
  responsive: true,
  loadingRows: 15
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/DataTables/DataTable.jsx